var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectoradd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.333984C3.32732 0.333984 0.333984 3.32732 0.333984 7.00065C0.333984 10.674 3.32732 13.6673 7.00065 13.6673C10.674 13.6673 13.6673 10.674 13.6673 7.00065C13.6673 3.32732 10.674 0.333984 7.00065 0.333984ZM9.66732 7.50065H7.50065V9.66732C7.50065 9.94065 7.27398 10.1673 7.00065 10.1673C6.72732 10.1673 6.50065 9.94065 6.50065 9.66732V7.50065H4.33398C4.06065 7.50065 3.83398 7.27398 3.83398 7.00065C3.83398 6.72732 4.06065 6.50065 4.33398 6.50065H6.50065V4.33398C6.50065 4.06065 6.72732 3.83398 7.00065 3.83398C7.27398 3.83398 7.50065 4.06065 7.50065 4.33398V6.50065H9.66732C9.94065 6.50065 10.1673 6.72732 10.1673 7.00065C10.1673 7.27398 9.94065 7.50065 9.66732 7.50065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectoradd);
export default __webpack_public_path__ + "static/media/Vectoradd.f1714ceadb1b6e49f923a6cabaec6e12.svg";
export { ForwardRef as ReactComponent };